import { reportFetcher, type FetchReportResult } from "../api/reportFetcher";

const cache: { [token: string]: FetchReportResult } = {};

async function fetchReportInner(token: string): Promise<FetchReportResult> {
  await reportFetcher.load(token);

  if (!reportFetcher.state.fetchResult) throw new Error("No fetch result");

  return reportFetcher.state.fetchResult;
}

export async function clearReportCache(token: string) {
  delete cache[token];
}

export async function fetchReport(
  token: string,
  opts = { resetCache: false },
): Promise<FetchReportResult> {
  if (!opts.resetCache && cache[token]) return cache[token];

  cache[token] = await fetchReportInner(token);

  return cache[token];
}
